import { Col, Row, Card, Table, Alert } from 'antd';
import React from 'react';
import { baseTableColumns, contractConfigColumns, expandIconRendering, getColumnsWithHighlight, getRowClassName, groupDifferencesByAction, renderColumn } from './helper';

export const FscContent = ({ data }) => {

    const renderRegularGroup = (changes, title, type) => {
        if (!changes?.length) return null;
        const verifyContractConfig = changes[0]?.new_value?.contract_config || changes[0]?.old_value?.contract_config;
        return (
          <div className="mb-6">
            <h4
              className="ant-typography ant-typography-md font-medium mb-3"
              style={{ textAlign: "left", fontSize: "16px" }}
            >
              {title}
            </h4>
            <Card
             style={{
              background: "#fff",
              borderRadius: "8px",
              boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
              marginBottom: "16px",
              padding: "2px",
            }}
            >
            {!_.isEmpty(verifyContractConfig) && <Alert message={_.startCase("Expand the Table to view the contract configuration for the surcharge.")} type={type === "REMOVED" ? "error" : "info"} className="customAlert" />}
              <Table
                columns={baseTableColumns.map(col => renderColumn(col, type))}
                dataSource={changes.map((change, index) => ({
                  ...((type === "ADDED" &&
                    change?.new_value ? change?.new_value
                    : change?.old_value) ?? {}),
                  key: index,
                }))}
                pagination={false}
                bordered
                expandedRowRender={(record) => {
                  if(!_.isEmpty(record.contract_config)){
                    return(
                      <div style={{ background: '#f9f9f9', height: '100%', width: '100%' }}>
                      <Table
                        columns={contractConfigColumns.map(col => renderColumn(col, type))}
                        dataSource={record.contract_config}
                        pagination={false}
                        bordered
                        scroll={{ x: 'max-content', y:100 }}
                      />
                      </div>
                    )
                  }
                  return null;
                }}
                expandIcon={(props) => expandIconRendering(props)}
              />
            </Card>
          </div>
        );
    };

    const renderModifiedGroup = (changes) => {
        if (!changes?.length) return null;

        const oldValues = changes.filter(change => change.old_value)
        .map((change, index) => ({
              ...change.old_value,
                key: `old-${index}-${change.old_value.code}`
            }));
        const newValues = changes.filter(change => change.new_value)
            .map((change, index) => ({
              ...change.new_value,
                key: `new-${index}-${change.new_value.code}`
            }));
            const newColumns = getColumnsWithHighlight(baseTableColumns, oldValues, newValues);

        return (
            <div className="mb-6">
                <h4 className="ant-typography ant-typography-md font-medium mb-3" style={{ textAlign: 'left', fontSize: '16px' }}>Modified Entries</h4>
                <h5 className="ant-typography ant-typography-sm font-medium mb-2" style={{ textAlign: 'left', color: '#666', fontWeight: 'bold' }}>Previous Values</h5>
                <div className="mb-4">
                    <Card
                     style={{
                      background: "#fff",
                      borderRadius: "8px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
                      marginBottom: "16px",
                      padding: "2px",
                    }}
                    >
                    {!_.isEmpty(oldValues[0]?.contract_config) && <Alert message={_.startCase("Expand the Table to view the contract configuration for the surcharge.")} type="info" className="customAlert" />}
                        <Table
                            columns={baseTableColumns}
                            dataSource={oldValues}
                            pagination={false}
                            bordered
                            expandedRowRender={(record) => {
                              if(!_.isEmpty(record.contract_config)){
                                return(
                                  <div style={{ background: '#f9f9f9', height: '100%', width: '100%' }}>
                                  <Table
                                    columns={contractConfigColumns}
                                    dataSource={record.contract_config}
                                    pagination={false}
                                    bordered
                                    scroll={{ x: 'max-content', y:100 }}
                                    rowClassName={(nestedRecord) => {
                                      const oldConfig = oldValues[0]?.contract_config;
                                      const newConfig = newValues[0]?.contract_config;
                                        return getRowClassName(nestedRecord, oldConfig, newConfig, true);
                                    }}
                                  />
                                  </div>
                                )
                              }
                              return null;
                            }}
                            expandIcon={(props) => expandIconRendering(props)}
                        />
                    </Card>
                </div>
                <h5 className="ant-typography ant-typography-sm font-medium mb-2" style={{ textAlign: 'left', color: '#666', fontWeight: 'bold' }}>Updated Values</h5>
                <div>
                    <Card
                     style={{
                      background: "#fff",
                      borderRadius: "8px",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.09)",
                      marginBottom: "16px",
                      padding: "2px",
                    }}
                    >
                      {!_.isEmpty(newValues[0]?.contract_config) && <Alert message={_.startCase("Expand the Table to view the contract configuration for the surcharge.")} type="info" className="customAlert" />}
                        <Table
                            columns={newColumns}
                            dataSource={newValues}
                            pagination={false}
                            bordered
                            expandedRowRender={(record) => {
                              if(!_.isEmpty(record.contract_config)){
                                return(
                                  <div style={{ background: '#f9f9f9', height: '100%', width: '100%' }}>
                                <Table
                                  columns={contractConfigColumns}
                                  dataSource={record.contract_config}
                                  pagination={false}
                                  bordered
                                  scroll={{ x: 'max-content', y:100 }}
                                  rowClassName={(nestedRecord) => {
                                    const oldConfig = oldValues[0]?.contract_config;
                                    const newConfig = newValues[0]?.contract_config;
                                      return getRowClassName(nestedRecord, oldConfig, newConfig, false)
                                }}
                                />
                                  </div>
                                )
                              }
                              return null;
                            }}
                            expandIcon={(props) => expandIconRendering(props)}
                        />
                    </Card>
                </div>
            </div>
        );
    };

    const fuelSurchargeData = data?.difference[0]?.fuel_surcharge ? data?.difference[0]?.fuel_surcharge : [];
    const validReferences = new Set(["RATE_SHEET", "LEVEL_OF_SERVICES"]);
    const isMultiDataScreen = validReferences.has(_.get(data, "reference"));
    const incomingAction = isMultiDataScreen ? fuelSurchargeData[0]?.action : data?.action;
    const groupedDifferences = groupDifferencesByAction({ action: incomingAction, difference: fuelSurchargeData });
    const showDataOrNot = isMultiDataScreen ? (!_.isEmpty(fuelSurchargeData[0]?.old_value) || !_.isEmpty(fuelSurchargeData[0]?.new_value)) : true;
    const incomingEntry = fuelSurchargeData[0]?.new_value ? "New Entry" : "Old Entry";

    const renderFuelSurchargeMain = () => {
        return (
            <div className="mt-6">
                <h4 className="ant-typography ant-typography-md font-medium mb-3" style={{ textAlign: 'left', fontSize: '18px' }}>
                    <span style={{ fontSize: '20px', color: '#395484' }}>Fuel Surcharge</span>
                    <div className="mt-6">
                        {renderRegularGroup(groupedDifferences.REMOVED, 'Deleted Entry', 'REMOVED')}
                        {renderRegularGroup(groupedDifferences.ADDED, incomingEntry, 'ADDED')}
                        {renderModifiedGroup(groupedDifferences.MODIFIED)}
                    </div>
                </h4>
            </div>
        );
    };

  return (
    <Row gutter={[16, 32]}>
        <Col span={24}>{showDataOrNot && renderFuelSurchargeMain()}</Col>
    </Row>
  );
};